<template>
	<App title="Rider">
		<Block>
			<template #header>
				<h3 class="block-title">Rider</h3>
			</template>
			<Datatable :options="options" :scopes="scopes" />
		</Block>
	</App>
</template>

<script lang="ts">
import Block from '@/vue/components/Block.vue'
import Datatable from '@/vue/components/Datatable.vue'
import App from '@/vue/templates/App.vue'
import { CellRender, Column } from '@/vue/utils/Datatable'
import { Component, toNative, Vue,Prop } from 'vue-facing-decorator'

@Component({
	components: {
		App,
		Block,
		Datatable,
	},
})
class Group extends Vue {

	

	@Prop({ type: Array, default: () => [] })
	readonly stations!: Array<any>


	get scopes() {
		if(this.$user.role !== 'super_admin') {
			return []
		}
        if (!this.stations || this.stations.length === 0) {
            return []
        }
        
        const stationTitles = this.stations.map((station: any) => station.title);
        
        return stationTitles; 
    }

	get buttons() {
		let buttons: any[] = []
		buttons.push('refresh')
		
		if (this.$user.role !== 'financier') {
			buttons.push({
				extend: 'create',
				attr: {
					href: this.route('rider.page.create'),
				},
			})
		}
		
		buttons.push('trashed')

		return buttons
	}

	get columns() {
		let columns: any[] = []
		columns.push({
			data: 'id',
			title: 'ID',
			orderable: true,
			name: 'id',
		})
		columns.push({
			data: 'Name',
			title: 'Full Name',
			name: 'fullname',
			render: (data: string, _type: any, row: any) => {
				const label = row.financier ? 'Financier' : 'Swap'
				const color = row.financier ? 'secondary' : 'success'
				return `${data}<br><span class="badge bg-${color} mt-1">${label}</span>`
			},
		})
		
		columns.push({
			data: 'engine.serial',
			title: 'Assigned Engine',
			name: 'engine.serial',
			orderable: true,
			
		})
		columns.push({
			data: 'riderable.title',
			title: 'Assigned Station/Cluster',
		})
		columns.push({
			data: 'claims_count',
			title: 'No. of Claims',
			orderable: true,
			name: 'claims_count',
		})
		columns.push({
			data: 'stat',
			title: 'status',
			orderable: true,
			name: 'status',
		})
		
		columns.push({
			data: 'phone',
			title: 'Phone',
			name: 'phone',
		})

		columns.push({
			data: 'created_at',
			title: 'Registered',
			render: CellRender.date(),
			orderable: true,
			name: 'created_at',
		})

		columns.push(Column.actions(this.$gate))

		return columns
	}

	get options() {
		return {
			ajax: {
				url: this.route('rider.ajax.table'),
				method: 'POST',
			},
			buttons: this.buttons,
			columns: this.columns,
			order: [[4, 'desc']],
		}
	}
}
export default toNative(Group)
</script>
